import { Entity, PrimaryKey, Property, ManyToOne } from '@mikro-orm/core';
import { Newsfeed } from './newsfeed.entity';

@Entity({ tableName: 'tags' })
export class Tag {
  @PrimaryKey({ autoincrement: true })
  id!: number;

  @ManyToOne(() => Newsfeed)
  newsfeed!: Newsfeed | null;

  @Property()
  title!: string;

  @Property()
  created_at: Date = new Date();

  @Property({ onUpdate: () => new Date() })
  updated_at: Date = new Date();

  @Property({ default: null })
  deleted_at?: Date;
}
